import { Button, Modal, Title, Text, Box, Icon } from '@nimbus-ds/components';
import { ExclamationTriangleIcon } from '@nimbus-ds/icons';
import { useTranslationCatalog } from 'domains/Catalog/hooks';

interface ErrorAIModalProps {
  onRetry: () => void;
  onDismiss: () => void;
}

function ErrorAIModal({ onRetry, onDismiss }: Readonly<ErrorAIModalProps>) {
  const t = useTranslationCatalog('products.fromImages.modal.error');

  return (
    <Modal open maxWidth="360px" padding="none" onDismiss={onDismiss}>
      <Modal.Body>
        <Box
          display="flex"
          flexDirection="column"
          gap="2"
          height="288px"
          justifyContent="center"
          alignItems="center"
        >
          <Icon source={<ExclamationTriangleIcon size="large" />} />
          <Title as="h4">{t('title')}</Title>
          <Text>{t('description')}</Text>
          <Button appearance="primary" onClick={onRetry}>
            {t('tryAgain')}
          </Button>
        </Box>
      </Modal.Body>
    </Modal>
  );
}

export default ErrorAIModal;
